import {Injectable} from '@angular/core';
import {RequestHeader} from '../../../shared/models/request-offer/request-header.model';
import {MessageType} from '../../../shared/models/request-offer/request-offer.enum';
import {v4 as uuid} from 'uuid';
import {LanguageService} from '../../../shared/services/language.service';
import {ProcessService} from '../process.service';
import {ProcessRequest} from '../../models/process-request.model';
import {RequestMetricResult} from '../../../shared/components/models/metrics/request-metric-result.enum';
import {MetricsService, RequestMetricName} from '../../../shared/services/metrics.service';
import {RestApiService} from '../../../shared/services/rest-api.service';
import {ConfigurationService} from './configuration/configuration.service';
import {ApiParamsService} from '../api-params.service';
import {ApiRequestKey} from '../../../shared/enums/api-request-key.enum';

@Injectable({
  providedIn: 'root'
})
export class PrepareRegistrationService {

  private readonly CLASSNAME = 'PrepareRegistrationService';
  private readonly API_REQUEST_KEY: ApiRequestKey = ApiRequestKey.PREPARE_REGISTRATION;
  private offerId: string;

  constructor(private languageService: LanguageService,
              private processService: ProcessService,
              private metricsService: MetricsService,
              private api: RestApiService,
              private configuration: ConfigurationService,
              private apiParamsService: ApiParamsService) { }

  sendPrepareRegistration(offerId: string): Promise<void> {
    this.offerId = offerId;
    const uri = this.configuration.uiConfig.prepareRegistrationEndpoint;

    let body: ProcessRequest = {
      header: this.buildRequestHeader()
    };

    let metricName = this.prepareMetrics(body);

    return this.api.post(uri, body)
      .then(() => { // RESPONSE
        this.metricsService.sendRequestMetric({
          ...metricName,
          type: RequestMetricResult.SUCCESS
        });
        return Promise.resolve();
      })
      .catch(error => { // RESPONSE
        console.error(error);
        this.metricsService.sendRequestMetric({
          ...metricName,
          type: RequestMetricResult.ERROR
        }, error);
        return Promise.reject(error);
      });
  }

  private buildRequestHeader(): RequestHeader {
    const requestId = uuid();

    return {
      languageCode: this.languageService.getDefaultLanguage().toUpperCase(),
      requestId: requestId,
      responseId: requestId,
      messageType: MessageType.OFFER,
      requestDate: new Date(),
      responseDate: new Date(),
      processContext: {
        processId: this.processService.processId,
        businessParameters: this.apiParamsService.createBusinessParams({
          requestKey: this.API_REQUEST_KEY,
          payload: {
            offerId: this.offerId
          }
        })
      },
      technicalParameters: this.apiParamsService.createTechnicalParams({
        requestKey: this.API_REQUEST_KEY
      })
    };
  }

  private prepareMetrics(data: ProcessRequest): any {
    let metricName = {
      className: this.CLASSNAME,
      methodName: 'sendPrepareRegistration'
    };

    this.metricsService.sendRequestMetric(<RequestMetricName>{
      ...metricName,
      type: RequestMetricResult.SEND
    }, data);

    return metricName;
  }
}
